import {EnumPricingItemType} from "./pricing-item-type";
import {EnumQuoteType} from "../../../enum/enum-quote-type";

export abstract class PricingItem {

    public id?: string;
    public family?: string;
    public isValid?: boolean;
    public userInputs?: Record<string, any>;
    public prefilledInputs?: any;
    public pricingItemType?: EnumPricingItemType;
    public totalAppliedPrice?: string;
    public productType?:
        | EnumQuoteType.CMC
        | EnumQuoteType.STANDARD;

    public initialStockLS?: string;
    public initialstockBillLS?: string;
    public unitStockInitialVT?: string;
    public totalStockInitialVT?: string;
    public displayOrder?: string

    public hasFranchiseConso?: () => boolean = () => false;
}
